const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";

@ccclass
export default class GameMorePanelView extends ViewBase {
    @property(cc.SpriteFrame)
    btnSprs:cc.SpriteFrame[] = []

    @property(cc.Sprite)
    soundBtnSpr:cc.Sprite = null

    @property(cc.Sprite)
    musicBtnSpr:cc.Sprite = null

    @property(cc.Label)
    labelServer:cc.Label = null

    updateBtnStatus(btnSpr:cc.Sprite, isOpen){
        btnSpr.spriteFrame =  isOpen ? this.btnSprs[0] : this.btnSprs[1]
    }

    @property(cc.Node)
    recordBtn:cc.Node = null
}

